<template>
  <div class="pInfo">
    <div class="eventRoute">
      当前位置：
      <span>
        展商中心首页
        <span class="x">/</span>
        <span style="cursor: pointer;" @click="backService">产品中心</span>
        <span class="x">/</span>
        产品详情
      </span>
    </div>
    <div class="content">
      <div class="c1">
        <div class="c1_left">
          <img :src="$getSrc(proInfo.pImg)" crossorigin alt />
        </div>
        <div class="c1_right">
          <div class="title">{{ proInfo.title }}</div>
          <p>
            所在地区：
            <span>{{  }}</span>
          </p>
          <p>
            最后更新：
            <span>{{ proInfo.createDate }}</span>
          </p>
         <!-- <p>
            关注度：
            <span>{{ proInfo.gzd }}</span>
          </p> -->
          <p>
            品牌展商：
            <span>{{  }}</span>
          </p>
          <el-button @click="messClick">在线留言</el-button>
        </div>
      </div>
      <div class="c2">
        <div class="c2_text" v-html="proInfo.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      proInfo: {
        title: "",
        createDate: "",
        gzd: "",
        pName: "",
        content: "",
        pImg: "",
        dq: "",
      },
    };
  },
  computed: mapState([
    "homeProductId",
    "proID"
  ]),
  mounted() {
    let queryExhibitorId = this.$route.query.exhibitor_id;
    if (queryExhibitorId) {
      this.pId_information(queryExhibitorId);
    } else if (this.homeProductId) {
      this.pId_information(this.homeProductId);
    } else if (this.proID) {
      this.pId_information(this.proID);
    }
  },
  methods: {
    // 资讯详情
    pId_information(id) {
      this.$http({
        url: "getAccConInfoById",
        method: "post",
        params: {
          accConId: id,
        },
      }).then(({ data }) => {
        let { code, accContentEntity } = data;
        if (code === 0) {
          this.proInfo.title = accContentEntity.title;
          this.proInfo.createDate = accContentEntity.createDate
            ? accContentEntity.createDate.substring(0, 16)
            : "";
          this.proInfo.gzd = accContentEntity.accountId;
          this.proInfo.pImg = accContentEntity.image;
          this.proInfo.content = accContentEntity.content.replace(
            /<img/g,
            "<img style='max-width: 100%;height: auto; crossOrigin; display: block; margin: 0 auto;'"
          );
        }
      });
    },

    backService() {
      this.$emit("frontPage", 1);
    },
    messClick() {
      this.$router.push({
        path: "/exhibitorHome/mess",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.pInfo {
  width: 1200px;
  min-height: 1194px;
  margin: 0 auto;
  .eventRoute {
    width: 1200px;
    margin: 0 auto;
    height: 60px;
    line-height: 60px;
    text-indent: 20px;
    font-size: 12px;
    color: #333333;
    // background-color: #f3f3f3;
    .x {
      margin: 0 7px;
    }
  }
  .content {
    min-height: 1134px;
    .c1 {
      width: 100%;
      height: 400px;
      background-color: #ffffff;
      margin-bottom: 20px;
      .c1_left {
        width: 420px;
        height: 320px;
        background-color: #e5e5e5;
        margin: 40px 0 40px 60px;
        float: left;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .c1_right {
        width: 632px;
        height: 274px;
        margin-top: 70px;
        float: right;
        color: #333333;
        .title {
          height: 28px;
          font-size: 28px;
          line-height: 28px;
          margin-bottom: 32px;
        }
        p {
          font-size: 14px;
          line-height: 30px;
        }
        .el-button {
          width: 200px;
          height: 50px;
          font-size: 14px;
          background-color: #ff6600;
          color: #ffffff;
          margin-top: 40px;
          &:focus {
            border-color: #ff6600;
          }
        }
      }
    }
    .c2 {
      width: 100%;
      min-height: 714px;
      background-color: #ffffff;
      padding-top: 1px;
      padding-bottom: 100px;
      .c2_text {
        width: 1043px;
        min-height: 110px;
        line-height: 30px;
        font-size: 14px;
        color: #333333;
        margin: 52px 0 60px 77px;
      }
    }
  }
}
</style>>